import { render, staticRenderFns } from "./SimilarIdeasPopup.vue?vue&type=template&id=6c6468cc&scoped=true&"
import script from "./SimilarIdeasPopup.vue?vue&type=script&lang=js&"
export * from "./SimilarIdeasPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6468cc",
  null
  
)

export default component.exports